export const textsTransport = {
  CREATE_TRANSPORT: 'Добавить новое ТС',
  EDIT_TRANSPORT: 'Редактировать ТС',
};
